import { render } from "./TermsPage.vue?vue&type=template&id=7113c4d2"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=7113c4d2&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script